module.exports = __webpack_public_path__ + "img/solve-problem.21c1d01a.svg";